type TwoColumnLayout<T extends string> = {
	mainItems: T[];
	moreItems: T[];
};

export const normalizeTwoColumnLayout = <T extends string>(
	mainItems: readonly T[],
	moreItems: readonly T[],
	availableItemIds: readonly T[]
): TwoColumnLayout<T> => {
	const availableItemIdSet = new Set(availableItemIds);
	const normalizedMainItems = Array.from(new Set(mainItems.filter((itemId) => availableItemIdSet.has(itemId))));
	const normalizedMainItemSet = new Set(normalizedMainItems);

	const normalizedMoreItems = Array.from(new Set(moreItems.filter((itemId) => availableItemIdSet.has(itemId) && !normalizedMainItemSet.has(itemId))));

	const assignedItems = new Set([...normalizedMainItems, ...normalizedMoreItems]);
	const unassignedItems = availableItemIds.filter((itemId) => !assignedItems.has(itemId));

	return {
		mainItems: normalizedMainItems,
		moreItems: [...normalizedMoreItems, ...unassignedItems],
	};
};
